import React, { useEffect } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { StatusTracker, WorkFlowPageLayout } from 'components'
import * as Types from 'types'
import * as actions from './actions'

const propTypes = {
  children: PropTypes.node.isRequired,
  currentStage: PropTypes.string,
  title: PropTypes.string.isRequired,
  stages: PropTypes.arrayOf(Types.stage),
  subject: PropTypes.string.isRequired,
  clearParticipantsData: PropTypes.func.isRequired,
  clearCompleteServicesAgreementForm: PropTypes.func.isRequired,
  resetErisapediaSearches: PropTypes.func.isRequired,
}

const defaultProps = {
  currentStage: null,
  stages: [],
}

function Layout({
  currentStage,
  children,
  title,
  stages,
  subject,
  clearParticipantsData,
  clearCompleteServicesAgreementForm,
  resetErisapediaSearches,
}) {
  useEffect(() => {
    return () => {
      clearParticipantsData()
      clearCompleteServicesAgreementForm()
      resetErisapediaSearches()
    }
  }, [])
  return (
    <WorkFlowPageLayout title={title} exitPromptSubject={subject}>
      <StatusTracker stages={stages} currentStageName={currentStage} />

      {children}
    </WorkFlowPageLayout>
  )
}

Layout.propTypes = propTypes

Layout.defaultProps = defaultProps

function mapStateToProps(/* state */) {
  return {}
}

const mapDispatchToProps = {
  clearParticipantsData: actions.clearParticipantsData,
  clearCompleteServicesAgreementForm:
    actions.clearCompleteServicesAgreementForm,
  resetErisapediaSearches: actions.resetErisapediaSearches,
}

export default compose(connect(mapStateToProps, mapDispatchToProps))(Layout)
